import { fromEvent, Observable } from 'rxjs';

export class RxUtils {
  static observeElementCssTransition(
    el: HTMLElement,
    {
      onStart,
      onEnd,
      onCancel,
    }: {
      onStart?: Function;
      onEnd?: Function;
      onCancel?: Function;
    } = {} as any
  ): Observable<void> {
    return new Observable((subscriber) => {
      subscriber.add(
        fromEvent(el, 'transitionstart').subscribe((e) => {
          onStart?.(e);
        })
      );

      subscriber.add(
        fromEvent(el, 'transitionend').subscribe((e) => {
          onEnd?.(e);
        })
      );

      subscriber.add(
        fromEvent(el, 'transitioncancel').subscribe((e) => {
          onCancel?.(e);
        })
      );
    });
  }

  static observeElementResize(...els: HTMLElement[]) {
    return new Observable<ResizeObserverEntry[]>((subscriber) => {
      const observer = new ResizeObserver((mutations) => {
        subscriber.next(mutations);
      });

      subscriber.add(() => {
        for (const el of els) {
          observer.unobserve(el);
        }

        observer.disconnect();
      });

      for (const el of els) {
        observer.observe(el);
      }
    });
  }
}
